import { IAdiRegistrationSetting, ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigAdiRegistrationSettings } from "./app-settings-config-adi-registration";

export interface IConfigAdiRegistrationInputState {
  showAdiRegistrationModal: boolean;
  editingAdiRegistrationId: string;
}

export interface IConfigAdiRegistrationInputProps {
  parentData: string;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigAdiRegistrationInput extends PureComponent<
  IConfigAdiRegistrationInputProps,
  IConfigAdiRegistrationInputState
> {
  formInputName: string[] = ["", "adiRegistrationSettingsId"];

  constructor(props: IConfigAdiRegistrationInputProps) {
    super(props);
    this.formInputName[0] = props.parentData;
    this.state = {
      showAdiRegistrationModal: false,
      editingAdiRegistrationId: ""
    };
  }

  openAdiRegistrationModal = (): void => {
    this.setState({
      editingAdiRegistrationId: "",
      showAdiRegistrationModal: true
    });
  };

  closeAdiRegistrationModal = (): void => {
    this.setState({ showAdiRegistrationModal: false });
  };

  setEditingAdiRegistration = (id: string): void => {
    this.setState({
      editingAdiRegistrationId: id,
      showAdiRegistrationModal: true
    });
  };

  render(): ReactNode {
    const options: IAdiRegistrationSetting[] = [
      {
        id: null,
        name: "Default"
      } as unknown as IAdiRegistrationSetting,
      ...(this.props.commonSettings.adiRegistrationSettings || [])
    ];
    return (
      <>
        <ConfigAdiRegistrationSettings
          formInputName={this.formInputName}
          closeModal={this.closeAdiRegistrationModal}
          showModal={this.state.showAdiRegistrationModal}
          editingAdiRegistrationId={this.state.editingAdiRegistrationId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="ADI Snippet"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey="android_playstoresettings_adiregistrationsnippet"
          onAddNew={this.openAdiRegistrationModal}
          onEdit={this.setEditingAdiRegistration}
          dropdownTestId="android_playstoresettings_adiregistrationsnippetDropdown"
          addNewTestId="android_playstoresettings_adiregistrationsnippetAddNewButton"
          editTestId="android_playstoresettings_adiregistrationsnippetEditButton"
        />
      </>
    );
  }
}
